var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "600px",
        persistent: "",
        transition: "dialog-bottom-transition"
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "v-flex",
            { attrs: { layout: "", md12: "", sm12: "", xs12: "" } },
            [
              _c(
                "div",
                { staticClass: "divP", attrs: { align: "left" } },
                [
                  _c("p", { staticClass: "aclaracion" }, [
                    _vm._v(
                      "\n          Se recomienda utilizar el formato de la siguiente plantilla para\n          evitar conflictos al momento de cargar la solicitud.\n          "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          Por favor, ingresar los datos según los formatos que se muestran en\n          la fila de ejemplo de la plantilla.\n        "
                    )
                  ]),
                  _c(
                    "v-layout",
                    { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { md12: "", sm4: "", xs4: "" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btnPlantilla",
                              attrs: { color: "primary", flat: "", small: "" },
                              on: { click: _vm.descargarPlantilla }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Descargar Plantilla")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("v-divider"),
          _c("br"),
          _c(
            "v-form",
            {
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "FormFieldsContainer",
                [
                  _c(
                    "v-flex",
                    { attrs: { layout: "", md12: "", sm12: "", wrap: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "error-messages": _vm.errors.collect("archivo"),
                          label: _vm.formFields.archivo.label,
                          clearable: "",
                          heigh: "",
                          readonly: "readonly"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$refs.image.click()
                          },
                          "click:clear": function($event) {
                            return _vm.eliminarNombre()
                          }
                        },
                        model: {
                          value: _vm.formFields.archivo.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.archivo, "value", $$v)
                          },
                          expression: "formFields.archivo.value"
                        }
                      }),
                      _c("input", {
                        key: _vm.idkey,
                        ref: "image",
                        staticStyle: { display: "none" },
                        attrs: {
                          id: "archivoExcel",
                          accept: ".csv, .xlsx, .xls",
                          type: "file"
                        },
                        on: { change: _vm.onFilePicked }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {},
            [
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { md7: "", sm6: "", xs6: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { md5: "", sm4: "", xs4: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.cerrarModal()
                            }
                          }
                        },
                        [_vm._v("Cancelar\n          ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          attrs: { disabled: false },
                          on: {
                            click: function($event) {
                              return _vm.handleClick()
                            }
                          }
                        },
                        [_vm._v("Guardar\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }